import { render, staticRenderFns } from "./ShoppingOneKeyDialog.vue?vue&type=template&id=510da804&scoped=true"
import script from "./ShoppingOneKeyDialog.vue?vue&type=script&lang=js"
export * from "./ShoppingOneKeyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510da804",
  null
  
)

export default component.exports